import React, { useState, useEffect, useMemo } from "react";
import "./index.css";
import TextField from "../../../../components/inputs/textfield";
import { userAreaList } from "../../../user/user.api";
import "./index.css";
import CustomTable from "../../../../components/table/table";
// import TextField from "../../../../../../../components/inputs/textfield";
// import { userAreaList } from "../../../../../user.api";

export default function AllocateAreaForm(props) {
  const {
    formvalues: initialFormValues = [],
    data = [],
    formData: incomingFormData = {},
    initialFormData = {},
    handleFormData,
    onSubmit,
    handleFormSubmit,
    formId,
  } = props;
  const [isActive, setIsActive] = useState(false);
  const defaultLeaseYear =
    parseFloat(props?.appdata?.capital_investment || 0) > 99 ? 90 : 30;
  const [formvalues, setFormValues] = useState(
    initialFormValues.length > 0
      ? initialFormValues
      : [
        {
          id: initialFormValues.id,
          location_id: "",
          sub_location: "",
          category: "",
          area_management_id: null,
          area_in_acres: "",
          rupees_in_lakhs_or_acres: "",
          built_space_type_name: "",
          area_managememt_sub_tables_id: "",
          area_in_sqft: "",
          load_factor: "",
          total_area: "",
          total_rentable_area: "",
          total_amount: "",
          years: "",
        },
      ]
  );
  // Prefill category & area_management_id when props.appdata loads
  useEffect(() => {
    if (props.appdata?.area_type) {
      setFormValues((prev) =>
        prev.map((item) => ({
          ...item,
          category:
            item.category ||
            (props.appdata.area_type === "built_up_space"
              ? "built-up"
              : props.appdata.area_type === "land_on"
                ? "land"
                : ""),
        }))
      );
    }
  }, [props.appdata?.area_type]);

  // useEffect(() => {
  //   setFormValues((prev) =>
  //     prev.map((item) =>
  //       item.category === "land"
  //         ? { ...item, years: item.years || defaultLeaseYear }
  //         : item
  //     )
  //   );
  // }, [defaultLeaseYear]);
  const [baseArea, setBaseArea] = useState([]);
  const [areaErrors, setAreaErrors] = useState({});
  const [formData, setFormData] = useState({
    ...initialFormData,
  });
  const handleAreaTextChange = (e, index) => {
    const { name, value } = e.target;
    const validNumber = /^\d*\.?\d*$/;

    // First check if it's a valid number
    if (!validNumber.test(value)) {
      return; // Don't update if not a valid number
    }

    const updated = [...formvalues];
    const currentMatchedArea = matchedArea(index);
    const maxArea = currentMatchedArea?.area_in_sqft || 0;

    // Validate if required area is less than available area
    if (Number(value) > Number(maxArea)) {
      setAreaErrors((prev) => ({
        ...prev,
        [index]: `Required area cannot exceed available area (${maxArea} Sq.ft)`,
      }));
    } else {
      // Clear error if it exists
      setAreaErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });

      // Update the form value
      updated[index] = {
        ...updated[index],
        [name]: value,
      };
      setFormValues(updated);
      handleFormData(updated); // Removed setTimeout as it's usually not needed
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    handleFormSubmit(formData); // Use latest prop value passed down
  };

  const getUserAreaList = () => {
    setIsActive(true);
    userAreaList().then((res) => {
      const mapAreaTypeToCaption = (t) => {
        switch (t) {
          case "built_up_space":
            return "built-up";
          case "land_on":
            return "land-on";
          case "equipped_facility":
            return "equipped-facility";
          default:
            return null;
        }
      };
      const currentCaption = mapAreaTypeToCaption(props?.appdata?.area_type);
      const fullList = res?.data || [];
      const filtered = currentCaption
        ? fullList.filter(
          (item) => item?.areasubs?.area_type_caption === currentCaption
        )
        : fullList;

      setBaseArea(filtered);

      if (initialFormValues.length > 0) {
        // Map to ensure area_management_id and category are set
        setFormValues(
          initialFormValues.map((item) => ({
            ...item,
            category:
              item.category ||
              (props.appdata?.area_type === "built_up_space"
                ? "built-up"
                : props.appdata?.area_type === "land"
                  ? "land"
                  : ""),
            area_management_id:
              item.area_management_id ||
              (props.appdata?.area_type === "built_up_space"
                ? 1
                : props.appdata?.area_type === "land"
                  ? 3
                  : null),
          }))
        );
      } else {
        // Use the first item from API response as template if available
        const templateItem =
          filtered.length > 0
            ? {
              id: filtered[0].id, // Use ID from filtered API
              location_id: "",
              sub_location: "",
              category:
                props.appdata?.area_type === "built_up_space"
                  ? "built-up"
                  : props.appdata?.area_type === "land_on"
                    ? "land"
                    : "",
              area_management_id:
                props.appdata?.area_type === "built_up_space"
                  ? 1
                  : props.appdata?.area_type === "land_on"
                    ? 3
                    : null,
              area_in_acres: "",
              rupees_in_lakhs_or_acres: "",
              built_space_type_name: "",
              area_in_sqft: "",
            }
            : {
              id: "", // Fallback if no API data
              location_id: "",
              sub_location: "",
              category:
                props.appdata?.area_type === "built_up_space"
                  ? "built-up"
                  : props.appdata?.area_type === "land_on"
                    ? "land"
                    : "",
              area_management_id:
                props.appdata?.area_type === "built_up_space"
                  ? 1
                  : props.appdata?.area_type === "land_on"
                    ? 3
                    : null,
              area_in_acres: "",
              rupees_in_lakhs_or_acres: "",
              built_space_type_name: "",
              area_in_sqft: "",
            };

        setFormValues([templateItem]);
      }

      setIsActive(false);
    });
  };

  useEffect(() => {
    getUserAreaList();
  }, []);

  const handleAdd = () => {
    if (formvalues.length < 3) {
      setFormValues([
        ...formvalues,
        {
          location_id: "",
          sub_location: "",
          category: "",
          area_in_acres: "",
          rupees_in_lakhs_or_acres: "",
          built_space_type_name: "",
          area_in_sqft: "",
        },
      ]);
    }
  };

  const handleRemove = (index) => {
    const updated = formvalues.filter((_, i) => i !== index);
    setFormValues(updated);
  };

  const handleCategoryChange = (e, index) => {
    const selectedCategory = e.target.value;
    let areaManagementId = null;

    if (selectedCategory === "built-up") {
      areaManagementId = 1;
    } else if (selectedCategory === "land") {
      areaManagementId = 3;
    }

    const updated = [...formvalues];
    updated[index] = {
      ...updated[index],
      category: selectedCategory,
      area_management_id: areaManagementId,
      sub_location: "",
      built_space_type_name: "",
    };

    setFormValues(updated);
    setTimeout(() => {
      handleFormData(updated);
    }, 100);
  };

  const getSubLocations = (locationId, areaManagementId) => {
    const fallbackCategoryId = 1; // built-up default, as in other forms
    return baseArea
      .filter(
        (item) =>
          String(item.location_id) === String(locationId) &&
          item.area_management_id === (areaManagementId || fallbackCategoryId)
      )
      .filter((item) => item.sub_location !== null)
      .map((item) => ({ id: item.id, sub_location: item.sub_location || "-" }));
  };

  const handleLocationChange = (e, index) => {
    const locationId = e.target.value;
    const updated = [...formvalues];

    updated[index] = {
      ...updated[index],
      [e.target.name]: locationId,
      sub_location: "",
      built_space_type_name: "",
      location:
        baseArea.find((a) => a.location_id === locationId)?.locations
          ?.locations || "",
    };

    setFormValues(updated);
    setTimeout(() => {
      handleFormData(updated);
    }, 100);
  };

  // const handleSubLocationChange = (e, index) => {
  //   const subLoc = e.target.value;
  //   const updated = [...formvalues];
  //   updated[index] = {
  //     ...updated[index],
  //     [e.target.name]: subLoc,
  //     built_space_type_name: "",
  //   };

  //   setFormValues(updated);
  //   setTimeout(() => {
  //     handleFormData(updated);
  //   }, 100);
  // };

  const handleSubLocationChange = (e, index) => {
    const subTableId = e.target.value;
    const matched = baseArea.find(
      (area) => String(area.id) === String(subTableId)
    );
    console.log(matched);

    const updated = [...formvalues];
    updated[index] = {
      ...updated[index],
      area_managememt_sub_tables_id: subTableId,
      sub_location: matched?.sub_location || "-",
      built_space_type_name: "",
      location_id: matched?.location_id || "",
    };

    setFormValues(updated);
    setTimeout(() => {
      handleFormData(updated);
    }, 100);
  };

  const handleBuiltTypeChange = (e, index) => {
    const { name, value } = e.target;
    const updated = [...formvalues];

    updated[index] = {
      ...updated[index],
      [name]: value,
    };

    // If category is built-up, derive the sub-table id for the selected built type
    const current = updated[index];
    if (current.category === "built-up") {
      const match = baseArea.find(
        (area) =>
          String(area.location_id) === String(current.location_id) &&
          String(area.sub_location) === String(current.sub_location) &&
          (area?.built_space_type?.name || "") === String(value)
      );
      updated[index].area_managememt_sub_tables_id = match?.id || "";
    }

    setFormValues(updated);
    setTimeout(() => {
      handleFormData(updated);
    }, 100);
  };
  const filteredAreaTypes = (index) => {
    const item = formvalues[index];
    if (!item?.location_id || !item?.sub_location) return [];

    const filtered = baseArea.filter(
      (area) =>
        area.location_id === item.location_id &&
        area.sub_location === item.sub_location &&
        area.built_space_type?.name
    );

    return Array.from(
      new Set(filtered.map((area) => area.built_space_type.name))
    );
  };

  const matchedArea = (index) => {
    const item = formvalues[index];
    return baseArea.find((area) => {
      const matchLocation =
        String(area.location_id) === String(item.location_id);
      const matchSubLocation = area.sub_location === item.sub_location;
      const matchCategory = area.areasubs?.type === item.category;

      const matchBuiltType =
        item.category === "built-up"
          ? area.built_space_type?.name === item.built_space_type_name
          : true;

      return (
        matchLocation && matchSubLocation && matchCategory && matchBuiltType
      );
    });
  };

  const matchedLandArea = (index) => {
    const item = formvalues[index];
    if (!item?.location_id || !item?.sub_location || !item?.category)
      return null;

    return baseArea.find(
      (area) =>
        area.location_id === item.location_id &&
        area.sub_location === item.sub_location &&
        area.area_management_id === item.area_management_id
    );
  };

  const handleTextChange = (e, index) => {
    const { name, value } = e.target;

    const updatedFormData = [...formvalues]; // or whichever data you are mapping
    updatedFormData[index][name] = value;

    handleFormData(updatedFormData); // Pass updated data to parent
  };

  const uniqueLocations = Array.from(
    new Map(
      baseArea?.map((area) => [area?.locations?.locations, area])
    ).values()
  );

  // Helper to format currency-like numbers with comma separation for display only
  const formatCurrency = (v) => {
    if (v === null || v === undefined || v === "") return "";
    const num = Number(v);
    if (Number.isNaN(num)) return v;
    try {
      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch (e) {
      return String(v);
    }
  };

  return (
    <div>
      {/* <div>Select Space as per Priority (Select Maximum 3 Locations)</div> */}
      {formvalues.map((item, index) => {
        const currentSubLocations = getSubLocations(
          item.location_id,
          item.area_management_id
        );
        const currentMatchedArea = matchedArea(index);
        const currentMatchedLandArea = matchedLandArea(index);
        const currentAreaTypes = filteredAreaTypes(index);

        return (
          <form key={index} id="allocateAreaForm" onSubmit={handleSubmit}>
            {props?.appdata.area_type === "built_up_space" && (
              <div className="row">
                <div className="col-12">
                  <CustomTable
                    className="areatable"
                    {...props}
                    columns={[
                      { title: "Preference No", field: "id", type: "dynId" },
                      { title: "Location", field: "location" },
                      { title: "Sub Location", field: "sub_location" },
                      {
                        title: "Category",
                        field: "area_type",
                        render: (rowData) =>
                          rowData.area_type === "built_up_space"
                            ? "Built-Up Space"
                            : "Land On Lease",
                      },
                      {
                        title: "Built-Up Space Category",
                        field: "built_space_type",
                      },

                      {
                        title: "Rentable Area(in sqft)",
                        field: "available_area",
                      },
                      {
                        title: "Area Requirement (Requested area in sqft)",
                        field: "area_in_sqft",
                      },
                      // {title: "Management plan", field: "management_plan" },
                    ]}
                    data={props?.appdata?.area_management}
                  />
                </div>
              </div>
            )}
            {props?.appdata.area_type === "equipped_facility" && (
              <div className="row">
                <div className="col-12">
                  <CustomTable
                    className="areatable"
                    {...props}
                    columns={[
                      { title: "Preference No", field: "id", type: "dynId" },
                      { title: "Location", field: "location" },
                      {
                        title: "Requested Area Requirement",
                        field: "area_in_sqft",
                      },
                    ]}
                    data={props?.appdata?.area_management}
                  />
                </div>
              </div>
            )}
            {props?.appdata.area_type === "land_on" && (
              <div className="row">
                <div className="col-12">
                  <CustomTable
                    className="areatable"
                    {...props}
                    columns={[
                      { title: "Preference No", field: "id", type: "dynId" },
                      { title: "Location", field: "location" },
                      { title: "Sub Location", field: "sub_location" },
                      {
                        title: "Category",
                        field: "area_type",
                        render: (rowData) =>
                          rowData.area_type === "built_up_space"
                            ? "Built-Up Space"
                            : "Land On Lease",
                      },
                      {
                        title: "Rentable Area(in cents)",
                        field: "available_area",
                      },
                      {
                        title: "Land Requirement(in cents)",
                        field: "area_in_acres",
                      },
                      { title: "Lease Years (based on capital investment)", field: "lease_year" },
                    ]}
                    data={props?.appdata?.area_management}
                  />
                </div>
              </div>
            )}
            {props?.appdata.area_type === "joint_venture" && (
              <div className="row">
                <div className="col-3">
                  Requested <br></br>Joint Venture
                </div>
                <div className="col-1">:</div>
                <div className="col-7 venure">
                  <CustomTable
                    className="areatable"
                    {...props}
                    columns={[
                      {
                        title: "Preference No",
                        field: "number",
                        type: "dynId",
                      },
                      { title: "Location", field: "location" },
                      { title: "Area in sq.ft", field: "area_in_sqft" },
                      { title: "Category", field: "area" },
                      {
                        title: "Investment Model",
                        field: "investment_model",
                      },
                      { title: "Management Plan", field: "management_plan" },
                      { title: "Address", field: "land_address" },
                    ]}
                    data={props?.appdata?.area_management}
                  />
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-6">
                <div className="fieldset">
                  <label className="mb-1">Location</label>
                  <select
                    className="form-select mandatory-select"
                    required
                    name="location_id"
                    onChange={(e) => handleLocationChange(e, index)}
                    value={item.location_id || ""}
                  >
                    <option value="">Location</option>
                    {uniqueLocations?.map((area) => (
                      <option key={area?.id} value={area?.location_id}>
                        {area?.locations?.locations}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div
                className={`col-6 
                 
                `}
              >
                <div className="fieldset">
                  <label className="mb-1">Sub Location</label>
                  <select
                    className="form-select mandatory-select"
                    required
                    name="sub_location"
                    onChange={(e) => handleSubLocationChange(e, index)}
                    value={item.area_managememt_sub_tables_id || ""}
                  >
                    <option value="">Select Sub Location</option>
                    {Array.from(
                      new Map(
                        (currentSubLocations || [])
                          .filter(Boolean)
                          .map((s) => [
                            String(s.sub_location || "").trim().toLowerCase(),
                            s,
                          ])
                      ).values()
                    ).map((subLoc) => (
                      <option key={subLoc.id} value={subLoc.id}>
                        {subLoc.sub_location}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-6">
                <div className="fieldset">
                  <label className="mb-1">Category</label>
                  <select
                    className="form-select mandatory-select"
                    required
                    name="category"
                    value={item.category || ""}
                    onChange={(e) => handleCategoryChange(e, index)}
                    disabled={true}
                  >
                    <option value="">Select Category</option>
                    <option value="land">Land On Lease</option>
                    <option value="built-up">Built-up Space</option>
                  </select>
                </div>
              </div>

              {item.category === "land" && (
                <div className="col-6 mt-3">
                  <TextField
                    label="Total Available Area"
                    name="available_area"
                    type="text"
                    value={currentMatchedLandArea?.available_area || ""}
                    onChange={(e) => handleTextChange(e, index)}
                    disabled
                    required
                  />
                </div>
              )}
              {item.category === "land" && (
                <div className="col-6 mt-3">
                  <TextField
                    label="Base premium (Rupees/cent)"
                    name="rupees_in_lakhs_or_acres"
                    type="text"
                    value={
                      currentMatchedLandArea?.rupees_in_lakhs_or_acres || ""
                    }
                    onChange={(e) => handleTextChange(e, index)}
                    disabled
                    required
                  />
                </div>
              )}

              {/* {item.category === "land" && (
                <div className="col-6 mt-3">
                  <TextField
                    label="Alloted Space(in cents)"
                    name="allotted_space"
                    type="text"
                    value={item.allotted_space || ""}
                    onChange={(e) => handleTextChange(e, index)}
                    required
                  />
                </div>
              )} */}

              {item.category === "built-up" && (
                <div className="col-6">
                  <div className="fieldset">
                    <label className="mb-1">Built Space Type</label>
                    <select
                      className="form-select mandatory-select"
                      name="built_space_type_name"
                      value={item.built_space_type_name || ""}
                      onChange={(e) => handleBuiltTypeChange(e, index)}
                      required
                    >
                      <option value="">Select Built Space Type</option>
                      {currentAreaTypes.map((typeName, idx) => (
                        <option key={idx} value={typeName}>
                          {typeName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {item.category === "built-up" && (
                <div className="col-6 mt-3">
                  <TextField
                    label="Total Available Area"
                    name="available_area"
                    type="text"
                    value={currentMatchedArea?.available_area || ""}
                    disabled
                    required
                  />
                </div>
              )}
              {item.category === "built-up" && (
                <div className="col-6 mt-3">
                  <TextField
                    label="Rent for sqft (Rupees/month)"
                    name="rupees_in_sqft"
                    type="text"
                    value={currentMatchedArea?.rupees_in_sqft || ""}
                    disabled
                    required
                  />
                </div>
              )}

              {/* Allotted Space */}
              {/* <div className="col-6 mt-3">
                <TextField
                  label={`Area Allotted (${
                    item.category === "built-up" ? "in Sq.ft" : "in Cents"
                  })`}
                  name="allotted_space"
                  type="text"
                  value={item.allotted_space || ""}
                  onChange={(e) => {
                    const updated = [...formvalues];
                    updated[index] = {
                      ...updated[index],
                      allotted_space: e.target.value,
                    };

                    const allotted = parseFloat(e.target.value || 0);
                    const load = parseFloat(updated[index].load_factor || 0);
                    const years = parseFloat(updated[index].years || 1);

                    // compute total_area
                    const totalArea = allotted + allotted * load;
                    updated[index].total_area = isNaN(totalArea)
                      ? ""
                      : totalArea.toFixed(2);

                    // compute total_amount depending on category
                    if (item.category === "built-up") {
                      const rupees = parseFloat(
                        currentMatchedArea?.rupees_in_sqft || 0
                      );
                      const amount = totalArea * rupees;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    } else if (item.category === "land") {
                      const rupees = parseFloat(
                        currentMatchedLandArea?.rupees_in_lakhs_or_acres || 0
                      );
                      const amount = totalArea * rupees * years;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    }

                    setFormValues(updated);
                    handleFormData(updated);
                  }}
                  required
                />
              </div> */}
              <div className="col-6 mt-3">
                <TextField
                  label={
                    item.category === "built-up"
                      ? "Proposed Area Allotment (in Sq.ft)"
                      : "Proposed Land Allotment (in Cents)"
                  }
                  name="allotted_space"
                  type="text"
                  value={item.allotted_space || ""}
                  onChange={(e) => {
                    const { value } = e.target;
                    const validNumber = /^\d*\.?\d*$/;
                    if (!validNumber.test(value)) {
                      return;
                    }
                    const updated = [...formvalues];
                    updated[index] = {
                      ...updated[index],
                      allotted_space: value,
                    };
                    // Recalculate totals to keep derived fields in sync
                    // For land, if load_factor not set yet, default to 1.0 so rentable gets computed
                    let load = parseFloat(updated[index].load_factor);
                    if (isNaN(load) || load <= 0) load = 1.0;
                    // Clamp to [1.0, 2.0] similar to load factor control
                    if (load < 1.0) load = 1.0;
                    if (load > 2.0) load = 2.0;
                    const allotted = parseFloat(value || 0);
                    const totalArea = allotted * load;
                    updated[index].total_area = isNaN(totalArea)
                      ? ""
                      : totalArea.toFixed(2);
                    updated[index].total_rentable_area = isNaN(totalArea)
                      ? ""
                      : totalArea.toFixed(2);
                    if (item.category === "built-up") {
                      const rupees = parseFloat(
                        currentMatchedArea?.rupees_in_sqft || 0
                      );
                      const amount = totalArea * rupees;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    } else if (item.category === "land") {
                      const rupees = parseFloat(
                        currentMatchedLandArea?.rupees_in_lakhs_or_acres || 0
                      );
                      const amount = totalArea * rupees;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    }
                    setFormValues(updated);
                    handleFormData(updated);
                  }}
                  required
                />
              </div>

              {/* Load Factor (common) */}
              {/* <div className="col-6 mt-3">
                <TextField
                  label="Load Factor"
                  name="load_factor"
                  type="number"
                  value={item.load_factor || ""}
                  onChange={(e) => {
                    const updated = [...formvalues];
                    updated[index] = {
                      ...updated[index],
                      load_factor: e.target.value,
                    };

                    const allotted = parseFloat(
                      updated[index].allotted_space || 0
                    );
                    const load = parseFloat(e.target.value || 0);
                    const years = parseFloat(updated[index].years || 1);

                    // compute total_area
                    const totalArea = allotted + allotted * load;
                    updated[index].total_area = isNaN(totalArea)
                      ? ""
                      : totalArea.toFixed(2);

                    // compute total_amount depending on category
                    if (item.category === "built-up") {
                      const rupees = parseFloat(
                        currentMatchedArea?.rupees_in_sqft || 0
                      );
                      const amount = totalArea * rupees;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    } else if (item.category === "land") {
                      const rupees = parseFloat(
                        currentMatchedLandArea?.rupees_in_lakhs_or_acres || 0
                      );
                      const amount = totalArea * rupees * years;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    }

                    setFormValues(updated);
                    handleFormData(updated);

                    // recalc rentable_area
                    const updatedAreaManagement =
                      props.appdata.area_management.map((row, i) => {
                        const sqft = parseFloat(row.area_in_sqft || 0);
                        const loadVal = parseFloat(
                          updated[i]?.load_factor || 0
                        );
                        const rentable = sqft + sqft * loadVal;

                        return {
                          ...row,
                          rentable_area: isNaN(rentable)
                            ? "0.00"
                            : rentable.toFixed(2),
                        };
                      });

                    props.setAppdata({
                      ...props.appdata,
                      area_management: updatedAreaManagement,
                    });
                  }}
                  required
                />
              </div> */}
              <div className="col-6 mt-3">
                <TextField
                  label="Load Factor"
                  name="load_factor"
                  type="text"
                  value={item.load_factor || ""}
                  onChange={(e) => {
                    const { value } = e.target;
                    // Allow empty while typing
                    if (value === "") {
                      const updatedEmpty = [...formvalues];
                      updatedEmpty[index] = {
                        ...updatedEmpty[index],
                        load_factor: "",
                      };
                      setFormValues(updatedEmpty);
                      handleFormData(updatedEmpty);
                      return;
                    }
                    // Only allow 1, 1.x, 1.xx, 2, 2., 2.0, 2.00
                    const validLoad = /^(1(\.\d{0,2})?|2(\.0{0,2})?)$/;
                    if (!validLoad.test(value)) {
                      return;
                    }
                    let loadNum = parseFloat(value);

                    // Clamp value between 1.00 and 2.00 for calculations only
                    if (loadNum < 1.0) loadNum = 1.0;
                    if (loadNum > 2.0) loadNum = 2.0;

                    const updated = [...formvalues];
                    updated[index] = {
                      ...updated[index],
                      // keep raw text so user can type intermediate states like '1.'
                      load_factor: value,
                    };

                    const allotted = parseFloat(
                      updated[index].allotted_space || 0
                    );
                    const totalArea = allotted * loadNum;

                    // save both total_area and total_rentable_area
                    updated[index].total_area = isNaN(totalArea)
                      ? ""
                      : totalArea.toFixed(2);
                    updated[index].total_rentable_area = isNaN(totalArea)
                      ? ""
                      : totalArea.toFixed(2);

                    // compute total_amount depending on category
                    if (item.category === "built-up") {
                      const rupees = parseFloat(
                        currentMatchedArea?.rupees_in_sqft || 0
                      );
                      const amount = totalArea * rupees;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    } else if (item.category === "land") {
                      const rupees = parseFloat(
                        currentMatchedLandArea?.rupees_in_lakhs_or_acres || 0
                      );
                      const amount = totalArea * rupees;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    }

                    setFormValues(updated);
                    handleFormData(updated);
                  }}
                  required
                />
              </div>
              {/* Years (only for land) */}
              {/* Capital Investment (shown always; disabled only when land) */}
              {item.category === "land" && (
                <div className="col-6 mt-3">
                  <TextField
                    label="Capital Investment (in Cr)"
                    name="capital_investment"
                    type="text"
                    value={props?.appdata?.capital_investment || ""}
                    onChange={(e) => {
                      if (props.setAppdata) {
                        props.setAppdata({
                          ...props.appdata,
                          capital_investment: e.target.value,
                        });
                      }
                    }}
                    disabled
                  />
                </div>
              )}
              {item.category === "land" && (
                <div className="col-6 mt-3">
                  <TextField
                    label={"Lease Years"}
                    name="years"
                    type="number"
                    value={item.years || ""}
                    onChange={(e) => {
                      const updated = [...formvalues];

                      updated[index] = {
                        ...updated[index],
                        years: e.target.value,
                      };

                      // keep the total_area as is
                      const totalArea = parseFloat(
                        updated[index].total_area || 0
                      );

                      // compute total_amount for land (area × rate)
                      const rupees = parseFloat(
                        currentMatchedLandArea?.rupees_in_lakhs_or_acres || 0
                      );
                      const amount = totalArea * rupees;

                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);

                      setFormValues(updated);
                      handleFormData(updated);
                    }}
                    required
                  />
                </div>
              )}

              {/* Rentable Area / Rentable land display */}
              <div className="col-6 mt-3">
                <TextField
                  label={
                    item.category === "land"
                      ? "Rentable land (in Cents)"
                      : `Rentable Area (${item.category === "built-up" ? "in Sq.ft" : "in Cents"})`
                  }
                  name="total_rentable_area"
                  type="text"
                  value={item.total_rentable_area || ""}
                  disabled
                />
              </div>

              {/* Total Area (only for built-up) */}
              {/* {item.category === "built-up" && ( */}
              <div className="col-6 mt-3">
                <TextField
                  // label={`Area Allotted (${item.category === "built-up" ? "in Sq.ft" : "in Cents"})`}
                  label={
                    item.category === "land"
                      ? "Land Alloted (Inclusive of Load Factor) (in Cents)"
                      : "Area Allotted (Inclusive of Load Factor) (in Sq.ft)"
                  }
                  name="total_area"
                  type="text"
                  value={item.total_area || ""}
                  onChange={(e) => {
                    const { value } = e.target;
                    const validNumber = /^\d*\.?\d*$/;
                    if (!validNumber.test(value)) {
                      return;
                    }
                    const updated = [...formvalues];
                    const newTotalArea = parseFloat(value || 0);

                    updated[index] = {
                      ...updated[index],
                      total_area: isNaN(newTotalArea) ? "" : newTotalArea,
                    };

                    // calculate total_amount based on category
                    if (item.category === "built-up") {
                      const rupees = parseFloat(
                        currentMatchedArea?.rupees_in_sqft || 0
                      );
                      const amount = newTotalArea * rupees;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    } else if (item.category === "land") {
                      const rupees = parseFloat(
                        currentMatchedLandArea?.rupees_in_lakhs_or_acres || 0
                      );
                      const amount = newTotalArea * rupees;
                      updated[index].total_amount = isNaN(amount)
                        ? ""
                        : amount.toFixed(2);
                    }

                    setFormValues(updated);
                    handleFormData(updated);
                  }}
                />
              </div>
              <div className="col-6 mt-3"></div>
              {/* Total Amount */}
              <div className="col-6 mt-3">
                <TextField
                  label={
                    item.category === "land"
                      ? "Total Lease Amount (Rupees/month)"
                      : "Monthly Rent(Inclusive of load factor)"
                  }
                  name="total_amount"
                  type="text"
                  value={formatCurrency(item.total_amount || "")}
                  disabled
                />
              </div>
            </div>
          </form>
        );
      })}
    </div>
  );
}
